export default "__VITE_ASSET__3ed19d26__"